module.exports = __webpack_public_path__ + "img/code.ee58325c.png";